<template>
  <nav>
    <div class="navbar-top" style="height: inherit;background-color: #333333">
      <ul class="tableshow" style="margin:0">
        <li class="fixed text-center" style="vertical-align: top;background-color: #333333">
          <div class="userba">
            <a :href="globalConfig.domain.portal">
            <img src="./img/logo.png" alt="" style="width: 150px">
<!--            <img src="./img/dx-logo-white.png" alt="" style="width: 150px">-->
          </a>
          </div>
        </li>
        <li class="tablecell respond" style="background: #333;">
          <div class="pull-right userba" style="margin-right: 225px;">
            <a :href="globalConfig.domain.portal+'/services'" title="数据保全-服务与支持">
              <img class="tf" src="./img/wenhao.png" alt="数据保全-服务与支持">
            </a>
          </div>
        <!--  <div class="pull-right userba" style="margin-right: 30px;">
            <a :href="globalConfig.domain.accountWeb+'/profile'">
            <img class="tf" src="./img/set.png" style="margin-right: 20px;"/>账户设置</a>
          </div>-->
          <div class="pull-right userba" style="margin-right: 50px">
            <template v-if="parentUserInfo.userId">
              <div class="text-center">
                <div class="block-userinfo userbar">
                  <a href="javascript:void(0)" id="addyangxin_div_block" class="username nomargin"
                     @mouseover="userDetailShow()" @mouseleave="userDetailHide()"
                     style="padding-left: 0;padding-right: 0; text-align: left; color: #ffffff">
                    <img :src="loginUser.realImgPath || '/static/img/defaultUserImg.jpg'"class="tf"  style="margin-right: 20px;border-radius:50%">
                    {{parentUserInfo.userName}}
                  </a>
                  <div class="user-info user" id="addyangxin_userInformation" v-show="this.isActive" @mouseleave="userInfoHide()">
                    <div class="sidebar-userinfo">
                      <div class="row nomargin">
                        <div class="col-xs-12 photomove">
                          <a :href="globalConfig.domain.accountWeb+'/profile?hm=1'" alt="" target="_blank">
                            <img :src="loginUser.realImgPath || '/static/img/defaultUserImg.jpg'" class="user-photo"
                                 :alt="parentUserInfo.userName">
                          </a>
                          <img src="./img/realN.png" class="realN" @click="toIdentity"/>
                        </div>
                        <div class="account-setting" @click="settings()" title="设置">
                          <!--<img src="./img/setting-black.png"/>-->
                        </div>
                        <div class="col-xs-12 loginuser">
                          <h5 style="width: 90px; margin-bottom: 4px;-ms-flex-wrap: nowrap;flex-wrap: nowrap; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{parentUserInfo.userName}}</h5>
                        </div>
                      </div>
                      <div class="row" style="border-bottom: 1px solid #dedede;">
                        <div class="col-xs-7">
                          <h5>积分数量：<span class="color-primary" id="head_user_point">{{parentUserInfo.point}}</span></h5>
                        </div>
                        <div class="col-xs-5">
                          <template v-if="parentUserInfo.userType == 0">
                            <a :href="globalConfig.domain.accountWeb+'/asset/toPointTask'" class="light-gray" target="_blank">积分任务</a>
                          </template>
                        </div>
                      </div>
                      <div class="row userba">
                        <div class="col-xs-6 nopadding">
                          <img src="./img/qdht.png" alt="" class="tf">
                          <a :href="globalConfig.domain.junziqianWebOp" alt="" class="pagefont-color" target="_blank">我的合同</a>
                        </div>
                        <div class="col-xs-6 nopadding">
                          <img src="./img/zscq.png" alt="" class="tf">
                          <a :href="globalConfig.domain.athenaWebUms" alt="" class="pagefont-color" target="_blank">我的原创</a>
                        </div>
                      </div>
                      <div class="row  userba">
                        <div class="col-xs-6 nopadding">
                          <img src="./img/dcqz.png" alt="" class="tf">
                          <a :href="globalConfig.domain.forensicsWebOp" alt="" class="pagefont-color">证据存证</a>
                        </div>
                      </div>
                      <div class="row" style="background-color:#f0f0f0;">
                        <div class="col-xs-6 text-left">
                          <template v-if="parentUserInfo.userType == 0">
                            <button v-if="!loginUser.signIn" class="btn btn-danger btn-signin" @click="clickSignIn()">签到</button>
                            <button v-else="" class="btn btn-danger btn-signin" disabled="disabled">已签到</button>
                          </template>
                        </div>
                        <div class="col-xs-6 text-right">
                          <a :href="globalConfig.domain.accountWeb+'/login/accountLogout?returnURL='+globalConfig.domain.forensicsWebOp+'/login.html'" @click="clearLocalInfo()"
                             class="light-gray">退出</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="pull-right userba">
                <a :href="globalConfig.domain.forensicsWebOp+'/register.html'" style="color: #fff;">注册</a>
              </div>
              <div class="pull-right userba">
                <a @click="gotoLogin()" href="javascript:void(0);"
                   style="padding: 0px 15px;color: #fff;">
                  登录
                </a>
              </div>
            </template>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import Vue from 'vue';
  import 'common/css/mapu.css';
  import http from 'common/js/http';
  import corsAjax from 'common/js/cors-ajax';
  import globalConfig from 'common/js/GlobalConfig'
  import layer from 'common/lib/layer/layer';
  import VueCookie from 'vue-cookie'

  export default {
    name: 'op-header',
    data () {
      return {
        isActive:false,
        loginUser:{},
        parentUserInfo:{},
      };
    },
    created(){
      var _this =this;
        this.doAfterSyncLogin(_this, function(){
        },true,1);
    },
    methods: {
        settings:function () {
            window.open(globalConfig.domain.accountWeb + '/profile?hm=1');
        },
      clickSignIn:function () {
        var _thisVue = this;
        http.post(globalConfig.domain.forensicsBackstage + "/account/signIn", {}, (response) => {
          let result = response.data;
          if (result.success) {
            _thisVue.loginUser.signIn = true;
            _thisVue.loginUser.point = result.data.point;
            _thisVue.updateLocalUser(_thisVue);
            layer.alert(result.message, {icon: 1, title: '系统提示'});
          } else if (result.code == 401) {
            layer.alert("登录已过期，请重新登录", {icon: 5, title: "系统提示"});
          } else {
            layer.alert(result.message, {icon: 5, title: "系统提示"});
          }
        });
      },
      userDetailShow:function(){
          this.isActive = true;
      },
      userDetailHide:function () {
        this.isActive = true;
      },
      userInfoHide:function () {
        this.isActive = false;
      },
      clearLocalInfo:function(){
        localStorage.clear();
        VueCookie.delete("token");
      },
      gotoLogin: function () {
        window.location.href = globalConfig.domain.forensicsWebOp + "/login.html";
      },
      toIdentity: function () {
          window.location.href = globalConfig.domain.accountWeb+'/userAuth/identity?productType=2&backUrl='+ encodeURIComponent(window.location.href);
      }
    }
  }
</script>

<style scoped>
nav .col-xs-4, nav .col-xs-2{
  padding-right:0;
}
.light-gray{
  color:#333 !important;
}
.pagefont-color{
  color:#525250 !important;
}
/*mapu copy*/
.block-userinfo {
  position: relative;
}

.block-userinfo .username {
  width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 10px;
  margin: 0 10px;
}

.block-userinfo .active {
  background: #fff;
  color: #10a0e9;
}

.block-userinfo .user-info {
  position: absolute;
  top: 40px;
  right: 0px;
  z-index: 1050;
  width: 300px;
  color: #525250;
  background: #fff;
  border: 1px solid #dedede;
}

.block-userinfo .user-info li {
  vertical-align: middle;
}

.block-userinfo .user-info .user-photo {
  height: 80px;
  width: 80px;
  border-radius: 50%;
}

.block-userinfo .user-info .details h5 {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 22px;
  margin: 0 0 4px 0;
}

.block-userinfo .user-info .details .list-icons {
  margin-bottom: 4px;
}

.block-userinfo .list-takes {
  padding: 0 15px;
}

.block-userinfo .list-takes ul {
  border-top: 1px solid #dedede;
}

.block-userinfo .list-takes ul li {
  padding-top: 10px;
}

.block-userinfo .list-takes ul li a {
  color: #525250 !important;
}

.block-userinfo .list-takes ul li a div {
  margin-top: 10px;
}
.h-time{
  line-height: 40px;
}
.btn-signin{
  width:55px;
  height:20px;
  border-radius:8px;
  font-size:12px;
  line-height:6px;
  margin-top:3px;
}
  .exit{
    padding:2px;
  }
  .photomove{
    position: absolute;
    top: -40px;
    right: 0;
  }
  .photomove>a{
    padding: 0px;
  }
  .loginuser{
    margin-top: 40px;
  }
  .loginuser>h5{
    position: relative;
    display: inline-block;
    margin:0;
  }
  .loginuser>h5>img{
    max-width: 14px;
    max-height: 14px;
    position: absolute;
    top: -5px;
  }
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: thin dotted;
  outline: none;
  outline-offset: 0;
}
  div.user a{
    display: inline-block;
    margin-left: 10px;
  }
  div.user a img{
    width:20px;
    height:20px;
    border-radius: 50%;
    margin-right:10px;
  }
.photomove a{
  position: relative;
}
  .realN{
    position: absolute;
    bottom: 0px;
    right: 110px;
    cursor: pointer;
  }
  .userba a{
    display: block;
    line-height: 38px;
  }
  .tf{
    max-width: 20px;
    max-height: 20px;
    vertical-align: top;
    margin-top:10px;
  }
.account-setting {
  width: 22px;
  height: 22px;
  background-image: url(/static/img/setting-black.png);
  background-position: center;
  background-size: cover;
  cursor: pointer;
  z-index: 10000;
  position: absolute;
  right: 10px;
}

.account-setting:hover{
  width: 22px;
  height: 22px;
  background-image: url(/static/img/settings-blue.png);
  background-position: center;
  background-size: cover;
  cursor: pointer;
  z-index: 10000;
  position: absolute;
  right: 10px;
}

</style>



// WEBPACK FOOTER //
// Header1.vue?f4b8c462